<template lang="pug">
.weight-card
    md-card(md-with-hover)
        md-card-media-cover(md-text-scrim)
          md-card-media(md-ratio="16:9")
            img(v-if="assist" :src="image_src" )
            img(v-else src="/static/img/horse-scale.png" )
        md-card-content
            div
              md-switch.md-primary(v-model="assist" ) {{$t('label.assistant')}}
            div(style="width:100%;margin-top:16px")
              h5.md-subhead(v-if="assist") 
                md-field(:class="{'md-invalid': errors.has('weight')}")
                  label {{$t('label.estimated')}}
                  md-input(type="number" readonly v-model.number="estimated" :data-vv-as="$t('label.gewicht')" data-vv-name="weight" v-validate.initial="fieldRules" data-vv-delay="200")
                  span.md-suffix kg
                  span.md-error(v-show="errors.has('weight')") {{ errors.first('weight') }}
            div(v-if="!assist" style="width:100%")
              md-field(:class="{'md-invalid': errors.has('weight')}")
                label {{$t('label.gewicht')}}
                md-input(type="number" v-model.number="horseWeight" :data-vv-as="$t('label.gewicht')" data-vv-name="weight" v-validate.initial="fieldRules" data-vv-delay="200")
                span.md-suffix kg
                span.md-error(v-show="errors.has('weight')") {{ errors.first('weight') }}
            div(v-else style="width:100%;margin-top:64px")
              .md-layout.md-gutter(style="text-align:right")
                .md-layout-item.md-size-50
                  md-field
                    label {{$t('label.circumference')}}
                    md-input(type="number" v-model.number="girth")
                    span.md-suffix cm
                .md-layout-item.md-size-50
                  md-field
                    label {{$t('label.bodylength')}}
                    md-input(md-numeric type="number" v-model.number="length" class="length" )
                    span.md-suffix cm
        md-card-actions(style="margin-top:24px")
          md-button.md-flat.md-accent#action(v-if="errors.any()" @click.native="expert=true" style="color: #012C58;") Ask the Expert
          span(style="flex:1;")
          md-button.md-raised.md-primary(:disabled="errors.any()" @click.native="setWeight(true)" style="color: #012C58;") {{$t('label.next')}}
    ask-the-expert(:show.sync="expert" :step="1")
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { SET_HORSE_WEIGHT, SET_WEIGHT_ID } from '@/constants/store'
export default {
  components: {
    AskTheExpert: () => import('@/components/AskTheExpert')
  },
  data () {
    return {
      horseWeight: 0,
      index: 0,
      assist: false,
      girth: 0,
      length: 0,
      expert: false
    }
  },
  mounted () {
    this.assist = false
    if (this.weightsByBreedType[0] !== undefined) {
      this.horseWeight = this.weightsByBreedType[3].value
      this.setWeight(false)
    }
  },
  watch: {
    weightsByBreedType () {
      this.assist = false
      if (this.weightsByBreedType[0] !== undefined) {
        this.horseWeight = this.weightsByBreedType[3].value
        this.setWeight(false)
      }
    }
  },
  computed: {
    ...mapState([
      'weights',
      'breedTypeIdx'
    ]),
    ...mapGetters([
      'weightsByBreedType',
      'horse'
    ]),
    weight () {
      return this.assist ? this.advised : (this.closest || {}).name
    },
    weightID () {
      return this.closest.weightID
    },
    image_src () {
      return '/static/img/wz_horsecalc_' + this.$i18n.locale + '.png'
    },
    estimated: {
      get () {
        return Math.round((this.girth * this.girth * this.length) / 11877)
      },
      set (value) {
        // ignore ?
      }
    },
    advised () {
      return Math.round((this.girth * this.girth * this.length) / 11877 / 50) * 50
    },
    closest () {
      return this.weights.reduce((prev, curr) => Math.abs(curr.value - this.horseWeight) < Math.abs(prev.value - this.horseWeight) ? curr : prev, { value: 0 })
    },
    fieldRules () {
      return {
        required: true,
        min_value: [this.minWeight],
        max_value: [this.maxWeight]
      }
    },
    minWeight () {
      return ((this.weightsByBreedType || [])[0] || {}).value || 0
    },
    maxWeight () {
      return ([...(this.weightsByBreedType || [])].pop() || {}).value || 1200
    }
  },
  methods: {
    setWeight (emit) {
      this.$store.commit(SET_HORSE_WEIGHT, this.assist ? this.estimated : this.horseWeight)
      this.$store.commit(SET_WEIGHT_ID, this.weightID)
      if (emit) {
        this.$emit('weight', this.weightID)
      }
    }
  }
}
</script>
<style scoped>
.md-card {
    margin: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/WeightCard.vue